// src/components/Anaco/AnacoHeader.js
// UPDATED: Added link for Análisis Avanzado (Advanced Tools/TerraPlan Vision)

import React from "react";
import { Link } from "react-router-dom"; // Import Link for navigation
import { FiLogIn, FiUserPlus } from "react-icons/fi";
import anacoLogoUrl from "../../images/anaco.png"; // Make sure this path is correct relative to this file

// --- Green/White/Grey Color Theme ---
const colors = {
  surface: "bg-white", // White for header background
  primary: "text-emerald-700", // Trustworthy Green for logo text/hover
  primaryBg: "bg-emerald-600", // Brighter Green for buttons
  primaryBgHover: "hover:bg-emerald-700",
  secondaryBg: "bg-slate-200", // Light grey for secondary buttons
  secondaryBgHover: "hover:bg-slate-300",
  textDark: "text-slate-800", // Dark grey for main text & nav links
  textLight: "text-white", // White text for primary button
  border: "border-slate-200", // Light border
};

const AnacoHeader = () => (
  <header
    className={`${colors.surface} shadow-sm z-40 border-b ${colors.border}`}
  >
    <nav className="container mx-auto px-4 sm:px-6 py-3 flex justify-between items-center">
      {/* Logo/Brand Name */}
      <Link
        to="/anaco" // Base Anaco link
        className="flex items-center gap-2 flex-shrink-0"
        aria-label="ANACO Inversiones Home"
      >
        <img src={anacoLogoUrl} alt="ANACO Logo" className="h-8 w-auto" />
        <span
          className={`text-xl font-semibold ${colors.primary} hidden sm:inline`}
        >
          Anaco
        </span>
        <span
          className={`text-xl font-semibold ${colors.textDark} hidden sm:inline`}
        >
          Inversiones
        </span>
      </Link>

      {/* === Navigation Links (UPDATED) === */}
      <div className="hidden md:flex items-center space-x-6 lg:space-x-8">
        <Link
          to="/anaco/about-us"
          className={`text-sm font-medium ${colors.textDark} hover:${colors.primary} transition-colors`}
        >
          Nosotros
        </Link>
        <Link
          to="/anaco/pre-approval-process"
          className={`text-sm font-medium ${colors.textDark} hover:${colors.primary} transition-colors`}
        >
          Proceso Pre-Aprobación
        </Link>
         {/* *** ADDED LINK for Advanced Tools / TerraPlan Vision *** */}
         <Link
          to="/anaco/advanced-tools-integration" // Link to the renamed vision page
          className={`text-sm font-medium ${colors.textDark} hover:${colors.primary} transition-colors`}
        >
          Análisis Avanzado
        </Link>
        <Link
          to="/anaco/marketplace"
          className={`text-sm font-medium ${colors.textDark} hover:${colors.primary} transition-colors`}
        >
          Propiedades
        </Link>
        <Link
          to="/anaco/calculator"
          className={`text-sm font-medium ${colors.textDark} hover:${colors.primary} transition-colors`}
        >
          Calculadora
        </Link>
        <Link
          to="/anaco/contact"
          className={`text-sm font-medium ${colors.textDark} hover:${colors.primary} transition-colors`}
        >
          Contacto
        </Link>
      </div>
      {/* === END Navigation Links === */}

      {/* Login/Register Buttons */}
      <div className="flex items-center space-x-3 flex-shrink-0">
        <Link
          to="/anaco/login"
          className={`hidden sm:inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md ${colors.textDark} ${colors.secondaryBg} ${colors.secondaryBgHover} transition-colors`}
        >
          <FiLogIn className="w-4 h-4 mr-2" />
          Iniciar Sesión
        </Link>
        <Link
          to="/anaco/register"
          className={`inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm ${colors.textLight} ${colors.primaryBg} ${colors.primaryBgHover} transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500`}
        >
          <FiUserPlus className="w-4 h-4 mr-2" />
          Registrarse
        </Link>
      </div>
    </nav>
  </header>
);

export default AnacoHeader;
